import {CensusHistorySimpleSerializer} from '../@core/api.service';

export interface ComplexEndDateEntry {
    end_date?: Date | string;
    end_date_expected?: Date | string;
    original_end_date?: Date | string;
    discontinued_reason?: string;
    discharge_date?: Date | string;
    discharge_census?: CensusHistorySimpleSerializer;
    origin?: string;
    patient?: {origin?: string};
}

export const processComplexEndDates = (entry: ComplexEndDateEntry) => {
    entry.original_end_date = entry.end_date;
    if (!entry.discharge_date && entry.discharge_census) entry.discharge_date = entry.discharge_census.timestamp;
    if (entry.discharge_date) entry.end_date = entry.discharge_date;
};
